export default {
  "/collection/record/index": [
    {
      path: "/collection/record/material",
      name: "collectionRecordMaterial",
      meta: {
        title: "还原材料",
        hiddenTag: true,
        matchedPath: "/collection/record/index",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/collection/record/upload",
      name: "collectionRecordMaterialUpload",
      meta: {
        title: "上传还原材料",
        hiddenTag: true,
        matchedPath: "/collection/record/index",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/collection/record/detail",
      name: "collectionRecordDetail",
      meta: {
        title: "交易记录详情",
        hiddenTag: true,
        matchedPath: "/collection/record/index",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/collection/record/m_detail",
      name: "collectionMaterialDetail",
      meta: {
        title: "还原材料详情",
        hiddenTag: true,
        matchedPath: "/collection/record/index",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/common/result",
      name: "collectionAccountResult",
      meta: {
        title: "添加成功",
        hiddenTag: true,
        matchedPath: "/collection/record/index",
        visible: "1",
        operate: "0"
      }
    }
  ],
  "/collection/account/index": [
    {
      path: "/collection/account/create",
      name: "collectionAccountCreate",
      meta: {
        title: "申请收款账户",
        hiddenTag: true,
        matchedPath: "/collection/account/index",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/collection/account/detail",
      name: "collectionAccountDetail",
      meta: {
        title: "账户明细",
        hiddenTag: true,
        matchedPath: "/collection/account/index",
        visible: "1",
        operate: "0"
      }
    }
  ]
};
